import instance from '../node_modules/i18next/dist/esm/i18next.js';
import translations from './translations.js';
import getClientEnvironment, { Environment } from './environmentModels.js';
import { initReactI18next } from '../node_modules/react-i18next/dist/es/context.js';

instance.use(initReactI18next).init({resources:translations,lng:"en_us",fallbackLng:"en_us",ns:"vistaprint",defaultNS:"vistaprint",debug:getClientEnvironment()!==Environment.Prod,interpolation:{escapeValue:false}});

export { instance as default };
//# sourceMappingURL=i18n.js.map
